import React, {useContext} from "react";
import {observer} from "mobx-react-lite";
import {Button, Col, CustomInput, FormGroup, Input, Label, Row} from "reactstrap";
import Select from "react-select";
import {FormattedMessage} from "react-intl";
import {StateContext} from "../../../App";
import {createCustomAjvValidator} from "../../../services/AjvValidator";
import {withTheme} from "@rjsf/core";
import {Theme as Bootstrap4Theme} from "@rjsf/bootstrap-4";
import {TimeZonePopUp} from "../../elements/timeZone/TimeZonePopUp";
import {DateTimeWidget} from "../../elements/dateTimeWidget/DateTimeWidget";
import {ObjectFieldTemplateProps} from "@rjsf/utils";
import {Roles} from "../../../utils/constants";
import DisableWrapper from "../../../utils/disableWrapper";


const ThemedForm = withTheme(Bootstrap4Theme);

const widgets = {
  timeZoneComponent: TimeZonePopUp,
  DateTimeWidget:DateTimeWidget
}



const schema = {
  type: 'object',
  required: [
    'status',
  ],
  properties: {
    status: {
      type: 'array',
      title: 'status',
      items: {
        type: 'object',
        "properties": {
          "statusType": {
            title: 'status',
            type: 'string',
            enum: ['PUBLISHED', 'COMPLETED', 'PAUSED'],
          },
          "date": {
            "type": "string",
            "title": "date time",
            "format": "date-time"
          }
        }
      },
      required: ['statusType', 'date'],
    },
    "timeZone": {
      "type": "string",
      "title": "Time Zone"
    }
  },
};

function ObjectFieldTemplate(props: ObjectFieldTemplateProps) {
    return (
      <>
          <Row>
              {props.properties.map((element) => {
                  if (!element.hidden) {
                      if (element.name === "timeZone") {
                          return null; // Return null for now, will handle it later
                      }
                      return <Col className='property-wrapper'>{element.content}</Col>;
                  }
                  return null;
              })}
          </Row>
          {props.properties
              .filter((element) => !element.hidden && element.name === "timeZone")
              .map((timeZoneElement) => (
                  <Row key={timeZoneElement.name} className='justify-content-center text-center'>{timeZoneElement.content}</Row>
              ))}
      </>
    );
}


const uiSchema = {
    status: {
      items: {
        'ui:options': { label: false},
        date : {
          "ui:widget": "DateTimeWidget"
        }
      },
  },
  "timeZone": {
    "ui:widget": "timeZoneComponent",
    "ui:className": "row"
  },
};


const StatusView = observer(({store, currentState}) => {
  const stateContext = useContext(StateContext);
  const editCodeState = stateContext.rootUiStore.editCodeState;
  const createCodeViewState = stateContext.rootUiStore.createCodeViewState;
  const editCodeViewState = stateContext.rootUiStore.editCodeState;
  const userRoles = stateContext.userRoles;
  const isDisabled = store.isView;
  //TODO: PATTERN VIOLATION - createCustomAjvValidator called on every render (affects 10+ components)
  // Correct solution: Use shared validator from RootUiState (see commented code in src/stores/RootUiState.js)
  // Replace with: const validator = stateContext.rootUiStore.ajvValidator;
  const validator = createCustomAjvValidator();
  // store.setDefaultStatusBasedOnRoles(userRoles);
  return (
    <DisableWrapper isDisabled={isDisabled}>
      <>
        {/*<FormGroup row>*/}
        {/*  <Col sm={5} className="text-left">*/}
        {/*    <Label>Publish When Update</Label>*/}
        {/*  </Col>*/}
        {/*  <Col className="d-flex justify-content-end">*/}
        {/*    <FormGroup check>*/}
        {/*      <CustomInput*/}
        {/*        type="switch"*/}
        {/*        id="statusChange"*/}
        {/*        name="statusChange"*/}
        {/*        label={"Yes"}*/}
        {/*        checked={store.publishOnUpdate}*/}
        {/*        onChange={() => store.handlePublishOnUpdate()}*/}
        {/*      />*/}
        {/*    </FormGroup>*/}
        {/*  </Col>*/}
        {/*</FormGroup>*/}
        <FormGroup row>
          <Col sm={5} className="text-left">
            <Label>Status</Label>
          </Col>

          {/*TODO: REFACTOR THIS*/}
          {!store.isEditForm && !store.isCloneForm && !store.isBatch && <Col md="6">
            <CustomInput
              type="select"
              className="react-select-container"
              classNamePrefix="react-select"
              value={store.status}
              id={store.status}
              defaultValue={store.status}
              onChange={(data) => store.changeStatus(data)}
            >
               {(userRoles.includes(Roles.ALL) || userRoles.includes(Roles.PUBLISH) || userRoles.includes(Roles.BATCH)) ?

                <>
                  <option value={'PUBLISHED'}>PUBLISHED</option>
                  <option value={'DRAFT'}>DRAFT</option>
                
                </> : <>
                  <option value={'DRAFT'}>DRAFT</option>
                </>
              }

            </CustomInput>
            <br/>
            {store.status === "PUBLISHED" ? <><i>When the configuration is applied and the code saved or updated,the new code will be <b> published.</b></i></> :
              <><i>When the configuration is applied and the code saved or updated, the new status will be applied.</i></>}
          </Col>}
          {store.isEditForm && <Col md="6">
            <CustomInput
              type="select"
              className="react-select-container"
              classNamePrefix="react-select"
              value={store.status}
              id={store.status}
              defaultValue={store.status}
              onChange={(data) => store.changeStatus(data)}
            >

               {userRoles.includes(Roles.ALL) || userRoles.includes(Roles.PUBLISH) || userRoles.includes(Roles.BATCH) ? (
                store.status === "DRAFT" ? (
                  <>
                    <option value={'DRAFT'}>DRAFT</option>
                    <option value={'PUBLISHED'}>PUBLISHED</option>
                  </>
                ) : (
                  editCodeViewState && editCodeViewState?.codeStatus === "PUBLISHED" || editCodeViewState?.codeStatus === "COMPLETED" || editCodeViewState?.codeStatus === "PAUSED" ? (
                    <>
                      <option value={'PUBLISHED'}>PUBLISHED</option>
                      <option value={'COMPLETED'}>COMPLETED</option>
                      <option value={'PAUSED'}>PAUSED</option>
                    </>
                  ) : <>
                    <option value={'DRAFT'}>DRAFT</option>
                    <option value={'PUBLISHED'}>PUBLISHED</option>
                  </>
                )
              ) : (
                <option value={'DRAFT'}>DRAFT</option>
              )}
            </CustomInput>
            <br/>
            {store.status === "PUBLISHED" ? <><i>When the configuration is applied and the code saved or updated,the new code will be <b> published.</b></i></> :
              <><i>When the configuration is applied and the code saved or updated, the new status will be applied.</i></>}
          </Col>}
          {store.isCloneForm && <Col md="6">
            <CustomInput
              type="select"
              className="react-select-container"
              classNamePrefix="react-select"
              value={store.status}
              id={store.status}
              defaultValue={store.status}
              onChange={(data) => store.changeStatus(data)}
            >

              {store.status === "DRAFT" ? (
                <>
                  <option value={'DRAFT'}>DRAFT</option>
                  <option value={'PUBLISHED'}>PUBLISHED</option>
                </>
              ) : (
                <>
                  <option value={'PUBLISHED'}>PUBLISHED</option>
                  <option value={'COMPLETED'}>COMPLETED</option>
                  <option value={'PAUSED'}>PAUSED</option>
                </>
              )}
            </CustomInput>
            <br/>
            {store.status === "PUBLISHED" ? <><i>When the configuration is applied and the code saved or updated,the new code will be <b> published.</b></i></> :
              <><i>When the configuration is applied and the code saved or updated, the new status will be applied.</i></>}
          </Col>}
          {store.isBatch && <Col md="6">
            <CustomInput
              type="select"
              className="react-select-container"
              classNamePrefix="react-select"  
              value={store.status}
              id={store.status}
              defaultValue={store.status}
              onChange={(data) => store.changeStatus(data)}
            >
              <option value={'COMPLETED'}>COMPLETED</option>
              <option value={'DRAFT'}>DRAFT</option>
              <option value={'PAUSED'}>PAUSED</option>
              <option value={'PUBLISHED'}>PUBLISHED</option>
            </CustomInput>
          </Col>}
        </FormGroup>

        <FormGroup row>
          <Col sm={5} className="text-left">
            <Label>Schedule Status Change</Label>
          </Col>
          <Col className="d-flex justify-content-end">
              <CustomInput
                checked={store.scheduleStatusChange}
                type="switch"
                id="schedulestatusChange"
                name="schedulestatusChange"
                label={"Yes"}
                value={store.scheduleStatusChange}
                onChange={() => store.setScheduleStatusChange()}
              />
          </Col>
        </FormGroup>
        {store.scheduleStatusChange &&  <FormGroup>
          <ThemedForm
            validator={validator}
            templates={{ ObjectFieldTemplate }}
            schema={schema}
            uiSchema={uiSchema}
            widgets={widgets}
            formData={store.statusScheduleDataView()}
            onChange={(data) => {
              store.setStatusScheduleData(data.formData);
            }}
            disabled={isDisabled}
          >
            <div></div>
          </ThemedForm>
        </FormGroup>}
        <FormGroup row>
          <Col sm={2}>
            <Button className="btn-outline-secondary mr-1" color="secondary" id="cancel-btn" onClick={async () => {
              // createCodeViewState && createCodeViewState.statusViewState.setStatus(createCodeViewState.status);
              // editCodeState && editCodeState.statusViewState.setStatus(editCodeState.codeStatus);
              // editCodeState && editCodeState.modalStore.toggle()
              // createCodeViewState && createCodeViewState.modalStore.toggle()
              let status;
              if (createCodeViewState) {
                status = createCodeViewState.status;
              } else if (editCodeState) {
                status = editCodeState.codeStatus;
              } else {
                status = currentState.codeStatus;
              }
              currentState.statusViewState.setStatus(status);
              currentState.modalStore.toggle()
              }}> <FormattedMessage id="createQr.advancedConfigsOptions.modalButtons.cancel.defaultMessage"/> </Button>
          </Col>
          <Col sm={10} className="text-right" onClick={async () => {
            createCodeViewState && createCodeViewState.setStatus(store.status);
            // createCodeViewState && createCodeViewState.setPublishOnUpdate(store.publishOnUpdate);
            editCodeState && editCodeState.setCodeStatus(store.status);
            // editCodeState && editCodeState.setPublishOnUpdate(store.publishOnUpdate);
            // editCodeState && editCodeState.modalStore.toggle()
            // createCodeViewState && createCodeViewState.modalStore.toggle()
            if(currentState !== createCodeViewState && currentState !== editCodeState) currentState.setCodeStatus(store);
            currentState.modalStore.toggle()
          }}>
            <Button outline color="primary"><FormattedMessage id="createQr.advancedConfigsOptions.modalButtons.apply.defaultMessage"/></Button>
          </Col>
        </FormGroup>
      </>
    </DisableWrapper>
  );
});

export default StatusView;
// </CustomInput>                    <CustomInput
//   className="w-auto"
//   type="select"
//   name="status"
//   value={store.status}
//   options={options}
//   onChange={(data) => store.changeStatus(data)}
// />
